import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { authSyncAPI } from "../api/services/authSyncAPI";
import { syncOrchestrator } from "../api/services/syncOrchestrator";
import { clearUser } from "../redux/slices/createUserSlice";

function clearAuthLocal() {
  try {
    localStorage.removeItem("authToken");
    localStorage.removeItem("syncToken");
    localStorage.removeItem("systemName");
    localStorage.removeItem("userCredentials"); // your slice mirror
  } catch {}
}

export default function useAuthSync(redirectOn401 = true) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const startedRef = useRef(false);

  useEffect(() => {
    const bootstrap = async () => {
      if (startedRef.current) return;
      startedRef.current = true;

      const authToken = localStorage.getItem("authToken");
      const systemName = localStorage.getItem("systemName");

      // No creds? Kick to login immediately
      if (!authToken || !systemName) {
        if (redirectOn401) navigate("/login", { replace: true });
        return;
      }

      try {
        // Try to resume server session
        await authSyncAPI.resume();

        // Session is valid, ensure orchestrator is running
        await syncOrchestrator.start();
      } catch (err) {
        const status = err?.response?.status || err?.status;
        // If server says this token is invalid/expired, log out + redirect
        if (status === 401) {
          try {
            await syncOrchestrator.stop?.();
          } catch {}
          clearAuthLocal();
          dispatch(clearUser());
          if (redirectOn401) navigate("/login", { replace: true });
        } else {
          // Non-401 can be retried silently by the orchestrator
          // console.warn("resume failed", err);
        }
      }
    };

    bootstrap();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectOn401]);
}
